import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'

export const BrokerFeature = {
  // Roles that are eligible for the Broker feature
  Roles: [MccsRoles.BROKER],

  // Determine if the feature is enabled for the given user
  isEnabled: (_: AuthResponse | null): boolean => false,
} satisfies Feature
